
const getWsUrl = () => {
  if (process.env.REACT_APP_WS_URL) return process.env.REACT_APP_WS_URL;
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const host = window.location.hostname === "localhost" ? "localhost:8000" : window.location.host;
  return `${protocol}//${host}/ws/dashboard`;
};

const WS_URL = getWsUrl();

export function connectDashboardWS({ onMessage, onOpen, onClose }) {
  let ws = null;
  let closed = false;

  try {
    ws = new WebSocket(WS_URL);

    ws.onopen = () => {
      if (onOpen) onOpen({ mock: false });
    };
    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        onMessage && onMessage(data);
      } catch (err) {
        onMessage && onMessage({ event: "RAW", payload: e.data });
      }
    };
    ws.onclose = () => {
      if (onClose) onClose();
    };
  } catch (e) {
    console.error("WebSocket Connection Failed", e);
  }

  return {
    close: () => {
      closed = true;
      if (ws && ws.readyState === WebSocket.OPEN) ws.close();
    },
    isMock: () => false,
  };
}
